import { MaterialForm } from '../../types';
import { getAspectRatio } from '../../utils/captureImage/captureImage';
import { useAutoCapture } from '../useAutoCapture/useAutoCapture';
import { useCameraStream } from '../useCameraStream/useCameraStream';
import { useDeviceShake } from '../useDeviceShake/useDeviceShake';
import { useTilt } from '../useTilt/useTilt';
import { useWakeLock } from '../useWakeLock/useWakeLock';

export const useCamera = ({ materialForm }: { materialForm: MaterialForm }) => {
  const { releaseWakeLock } = useWakeLock();
  const { isCameraLevel, isPortrait } = useTilt();
  const { isStill } = useDeviceShake();
  const aspectRatio = getAspectRatio({ isPortrait, materialForm });
  const { stream, releaseStream, isLoading } = useCameraStream({ aspectRatio });

  const isDeviceReady = isStill && isCameraLevel;
  const { autoCapturing, countdown, toggleAutoCapture, shouldCapture, markCaptureTriggered } = useAutoCapture({
    isDeviceReady,
  });

  return {
    autoCapturing,
    countdown,
    isDeviceReady,
    isLoading,
    isPortrait,
    markCaptureTriggered,
    releaseStream,
    releaseWakeLock,
    shouldCapture,
    stream,
    toggleAutoCapture,
  };
};
